import { get } from 'lodash';
import React, { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import useT from '../../utils/Translations/useT';
import { RETURN_TYPE } from '../base/SelectBox';
import SelectBoxFilter from './SelectBoxFilter';
import intakesListByPersonId from '../../../data/intakesListByPersonId.graphql';
import getGqlOperationName from '../../../utils/getGqlOperationName';
import Error from '../../utils/Error';
const IntakesListSelector = ({ value, onChange, personId, ...rest }) => {
    const t = useT();
    const { loading, error, data } = useQuery(intakesListByPersonId, {
        variables: { personId },
        skip: !personId,
    });
    const intakes = useMemo(() => get(data, getGqlOperationName(intakesListByPersonId), []), [data]);
    const isDisabled = useMemo(() => !personId || loading, [personId, loading]);
    if (error) {
        return <Error error={error}/>;
    }
    return (<SelectBoxFilter disabled={isDisabled} itemTitlePropName="name" itemValuePropName="id" options={intakes} returnType={RETURN_TYPE.NUMBER} title={t('Intake')} value={value} onChange={onChange} {...rest}/>);
};
export default IntakesListSelector;
